import { render } from "./FormTwkUitgebreidView.vue?vue&type=template&id=6b62e97a"
import script from "./FormTwkUitgebreidView.vue?vue&type=script&lang=js"
export * from "./FormTwkUitgebreidView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__